/* eslint-disable no-debugger */
import { useContext } from 'react';

import { MeetFormatStateContext } from './MeetFormatContextProvider';

import MeetFormatData from './MeetFormatData';

const useMeetFormatData = () => {
  const [meetFormatState, setMeetFormatState] = useContext(MeetFormatStateContext);
  const getMeetFormats = () => { 
    MeetFormatData.getMeetFormats(meetFormatState, setMeetFormatState); 
  }

  return {
    meetFormatState,
    getMeetFormats
  };
};

export default useMeetFormatData;